const imp = () => import(/* webpackChunkName: "loadSprite_app_s_a"*/  "../sprite/loadSprite_app_s_a");
const loadMap_app_s_a: { [key: string]: () => Promise<any> } = {
  "Icon--Import-and-export": imp,
  "Icon-Ask-every-day-o": imp,
  "Icon-Arithmetic-control-o": imp,
  "Icon-Ask-every-day": imp,
  "Icon-Audit-log-o": imp,
  "Icon-Audit-log": imp,
  "Icon-Automated-workflow-o": imp,
  "Icon-Automated-workflow": imp,
  "Icon-Basic-settings-o": imp,
  "Icon-Basic-settings": imp,
  "Icon-Configuration-center-o": imp,
  "Icon-Ctrip-o": imp,
  "Icon-Configuration-center": imp,
  "Icon-Ctrip": imp,
  "Icon-Development-platform-o": imp,
  "Icon-Document-management-o": imp,
  "Icon-Document-management": imp,
  "Icon-ESB-Center-o": imp,
  "Icon-ESB-Center": imp,
  "Icon-Import-and-export-o": imp,
  "Icon-Import-and-export": imp,
  "Icon-It's-over": imp,
  "Icon-Management-by-objectives-o": imp,
  "Icon-Management-by-objectives": imp,
  "Icon-Mobile-management-platform-o": imp,
  "Icon-Mobile-management-platform": imp,
  "Icon-Multilingual": imp,
  "Icon-Multilingual-o": imp,
  "Icon-Development-platform": imp,
  "Icon-Not-started": imp,
  "Icon-Official-document-o": imp,
  "Icon-Official-document": imp,
  "Icon-Operation-and-maintenance-platform-o": imp,
  "Icon-Operation-and-maintenance-platform": imp,
  "Icon-Operation-log-o": imp,
  "Icon-Operation-log": imp,
  "Icon-Operation-log02": imp,
  "Icon-Organization-Center-Authority-o": imp,
  "Icon-Organization-Center-Authority": imp,
  "Icon-Organization-authority-center": imp,
  "Icon-Place-of-attendance": imp,
  "Icon-Problem-reporting-o": imp,
  "Icon-Problem-reporting": imp,
  "Icon-Third-party-plug-in-o": imp,
  "Icon-Third-party-plug-in": imp,
  "Icon-Working-portrait": imp,
  "Icon-Working-portrait-o": imp,
  "Icon-crm-o": imp,
  "Icon-crm": imp,
  "Icon-data-security-o": imp,
  "Icon-data-security": imp,
  "Icon-delete备份": imp,
  "Icon-e-builde": imp,
  "Icon-e-builder-o": imp,
  "Icon-e-builder": imp,
  "Icon-financial-budget-o": imp,
  "Icon-financial-budget": imp,
  "Icon-have-in-hand": imp,
  "Icon-okr": imp,
  "Icon-system-log-o": imp,
  "Icon-system-log": imp,
  "Icon-okr-o": imp,
  "Icon-My-other-teams": imp,
  "Iconokr-o": imp,
  "Icon-crmHome-o": imp,
  "Icon-crmHome": imp,
}

export default loadMap_app_s_a;
